
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import ContactCard from '@/components/ContactCard.vue';

@Component({
  components: { Header, ContactCard },
})
export default class Contact extends Vue {}
